export default [
  {
    title: 'Results of state-of-the-art industries concentrated in DATA CENTER GAK Sejong',
    desc: "Korea's largest hyperscale DATA CENTER GAK Sejong has all state-of-the-art industries centering around the latest robot system concentrated in it.",
    srcMo: '/img/about/idea/idea-s3-c1.s.jpg',
    imgSrc: '/img/about/idea/idea-s3-c1.xxl.jpg',
  },
  {
    title: 'To keep our environment whole and data secure DATA CENTER GAK Chuncheon',
    desc: 'Completed utilizing the natural characteristics to the fullest, DATA CENTER GAK Chuncheon is the first data center of NAVER.',
    srcMo: '/img/about/idea/idea-s3-c2.s.jpg',
    imgSrc: '/img/about/idea/idea-s3-c2.xxl.jpg',
  },
  {
    title: 'One base to connect the world, DATA CENTER GAK Global',
    desc: 'DATA CENTER GAK Global with locations in 10 countries around the world provides the same cloud environment anytime and anywhere based on our proven infrastructure.',
    srcMo: '/img/about/idea/idea-s3-c3.s.jpg',
    imgSrc: '/img/about/idea/idea-s3-c3.xxl.jpg',
  },
];
